import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  USER_RESTAURANT_FAVOURITES,
  USER_OFFER_FAVOURITES,
  USER_EVENT_FAVOURITES,
  GET_GROUP_BY_FAVOURITES,
} from "../../types";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";

export const getAllFavouritesRestaurant =
  (startDate, endDate, onSuccesGetRestaurant, onErrorrGetRestaurant) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_restaurant_data = await axios.get(
        `${serverApi}/activity-tracker?status=2&startDate=${startDate}&endDate=${endDate}`
      );
      if (get_restaurant_data.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: USER_RESTAURANT_FAVOURITES,
          payload: get_restaurant_data,
        });
      }
      onSuccesGetRestaurant();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrGetRestaurant();
    }
  };

export const getAllFavouritesOffers =
  (startDate, endDate, onSuccesGetOffers, onErrorrGetOffers) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_offer_data = await axios.get(
        `${serverApi}/activity-tracker?status=3&startDate=${startDate}&endDate=${endDate}`
      );
      if (get_offer_data.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: USER_OFFER_FAVOURITES,
          payload: get_offer_data,
        });
      }
      onSuccesGetOffers();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrGetOffers();
    }
  };

export const getAllFavouritesEvents =
  (startDate, endDate, onSuccesGetEvents, onErrorrGetEvents) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_event_data = await axios.get(
        `${serverApi}/activity-tracker?status=4&startDate=${startDate}&endDate=${endDate}`
      );
      if (get_event_data.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: USER_EVENT_FAVOURITES,
          payload: get_event_data,
        });
      }
      onSuccesGetEvents();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrGetEvents();
    }
  };

export const getGroupByFavourites =
  (val, onSuccesGetGroupBy, onErrorGetGroupBy) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_groupby_data = await axios.get(
        `${serverApi}/favourites?val=${val}&groupBy=true`
      );
      if (get_groupby_data.status === 200) {
        onSuccesGetGroupBy();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_GROUP_BY_FAVOURITES,
          payload: get_groupby_data.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorGetGroupBy();
    }
  };
